/* eslint-disable */
import axios, { AxiosError, AxiosResponse } from 'axios'
import classNames from 'classnames'
import { t } from 'i18next'
import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from 'react'
import { PulseLoader } from 'react-spinners'
import { toast } from 'react-toastify'
import { getCodeDescription } from '../../../api/codedescapi'
import { postPolicyQuote } from '../../../api/policyquote'
import { getSchools } from '../../../api/schoolapi'
import { getOrgLocationByOrgGuid, getSchoolBoards } from '../../../api/schoolboardapi'
import config from '../../../config'
import childPlanFormDataContext, {
    IChildPlanFormData,
} from '../../../contexts/ChildPlanFormDataContext'
import ParentFormDataContext, {
    IParentFormData,
} from '../../../contexts/ParentFormDataContext'
import { disableProvinceDDL, getToday } from '../../../contexts/contextDataObjects/ParentDataObject'
import { ICodeDescription } from '../../../model/ICodeDescription'
import { IPlan } from '../../../model/IPlan'
import { IPolicyQuoteRequest } from '../../../model/IPolicyQuoteRequest'
import { formatInputDate, parseDate } from '../../../utils/patternHelper'
import { setRouteParam } from '../../../utils/routeHelper'
import ButtonSelect, {
    IButtonSelectItem,
} from '../../buttonSelect/ButtonSelect'
import CalendarIcon from '../../datetimePicker/CalendarIcon'
import DropDownList, { ddlListItem } from '../../dropDownList/DropDownList'
import InputBox from '../../inputBox/InputBox'

export interface IChildPlans {
    className?: string
    forwardedAutoEnrollRef: React.RefObject<HTMLDivElement>
}
// Functionalities: 1. catch all the error messages which res status equals to 400; 
// 2. the same error message will only be saved once
export async function fetchPolicyQuoteErrorMessages(
    parentData: IParentFormData,
    childData: IChildPlanFormData[],
    setParentFormData: Dispatch<SetStateAction<IParentFormData>>,
) {
    let insureds: any = []
    childData.map((child: IChildPlanFormData, index) => {
        if (child.Plan.PlanCode != "") {
            let childInfo = {
                planCode: child.Plan.PlanCode,
                organizationSchoolId: child.School.id ? child.School.id : -1,
                dob: child.Dob ? child.Dob : new Date(2022, 1, 1),
                firstname: index.toString(),
            }
            insureds.push(childInfo)
        }
    })
    const quoteRequest: IPolicyQuoteRequest = {
        provstate: parentData?.Province?.id ? parentData?.Province?.id : 'ON',
        language: parentData?.Language,
        emailAddress: parentData.Email ? parentData.Email : '',
        effectivedate: parentData.StartDate ? parentData.StartDate : new Date(),
        insureds: insureds,
    }
    try {
        if (insureds.length > 0) {
            await postPolicyQuote(quoteRequest)
        }
    } catch (error: any | AxiosError) {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError
            const axiosRespone = axiosError.response as AxiosResponse
            if (axiosRespone.status === 400) {
                setParentFormData((prevFormData) => {
                    if (!prevFormData.QuoteErrorMessages.includes(axiosRespone.data.error.message)) {
                        const newFormData = {
                            ...prevFormData,
                            QuoteErrorMessages: [...prevFormData.QuoteErrorMessages, axiosRespone.data.error.message]
                        }
                        return newFormData
                    }
                    else {
                        const newFormData = {
                            ...prevFormData,
                            QuoteErrorMessages: [...prevFormData.QuoteErrorMessages]
                        }
                        return newFormData
                    }
                })
            }
        }
    }
}

const ChildPlans: React.FC<IChildPlans> = ({
    className,
    forwardedAutoEnrollRef
}) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )

    const { childPlanFormData, setChildPlanFormData } = useContext(
        childPlanFormDataContext
    )

    const [isLoading, setIsLoading] = useState<boolean>(false) //used for making a component responsive with a spinner (for the future)
    //Placeholder
    const [enrollOptions, setEnrollOptions] = useState<IButtonSelectItem[]>([
        {
            mainText: 'Yes',
            secondaryText: '',
            index: 0,
            value: 'Yes',
            name: 'AutoEnroll',
        },
        {
            mainText: 'No',
            secondaryText: '',
            index: 1,
            value: 'No',
            name: 'AutoEnroll',
        },
    ])
    const [isModalOpen, setIsModalOpen] = useState(false)

    const [plans, setPlans] = useState<IPlan[]>()
    const [premiums, setPremiums] = useState<IPlan[]>()
    const [premiumOptions, setPremiumOptions] = useState<{
        [key: string]: number
    }>({})

    const [planDurations, setPlanDurations] = useState<ICodeDescription[]>([])
    const [planDurationOptions, setPlanDurationOptions] = useState<
        IButtonSelectItem[]
    >([])

    const [plansLoading, setPlansLoading] = useState<boolean>(false)
    const [premiumsLoading, setPremiumsLoading] = useState<boolean>(false)
    const [planDurationsLoading, setPlanDurationsLoading] =
        useState<boolean>(false)
    const [inputDateValue, setInputDateValue] = useState('')
    const [orgLocationOption, setOrgLocationOption] = useState<ddlListItem>()

    const maxMonth = Number(config.REACT_APP_MAXPOLICY)
    const maxDate = new Date()
    maxDate.setMonth(maxDate.getMonth() + maxMonth)
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate())
    today.setDate(today.getDate())
    const minDate = today

    const [learnMoreOpen, setLearnMoreOpen] = useState(false)

    useEffect(() => {
        if (parentFormData?.Province?.id) {
            if (parentFormData.OrgGuid) {
                fetchLocationByOrgGuid(parentFormData.OrgGuid, parentFormData?.Province?.id)
            } else {
                fetchSchoolBoards(parentFormData.Province)
            }
        }
    }, [parentFormData?.Province?.id])

    useEffect(() => {
        getPlanDurations(parentFormData.Language)
    }, [parentFormData.Language])

    useEffect(() => {
        if (
            parentFormData?.SchoolBoard?.id &&
            parentFormData?.SchoolBoard?.id != -1
        ) {
            fetchSchools(parseInt(parentFormData.SchoolBoard.id))
        }
    }, [parentFormData?.SchoolBoard?.id])

    useEffect(() => {
        if (planDurationOptions.length > 0 && parentFormData.PlanDuration.DurationText === '') {
            setDefaultPlanDuration()
        }
        if (orgLocationOption && parentFormData.CommonChildPlanFormInputData.ListItems[0]?.id === '') {
            setDefaultOrgLocation(orgLocationOption)
            disableProvinceDDL(parentFormData, setParentFormData)
        }
    }, [parentFormData])

    useEffect(() => {
        setPremiumOptions({})
        let temp: any = {}
        premiums?.map((prem: IPlan) => {
            temp[prem.plancode] = prem.premium
        })
        setPremiumOptions(temp)
    }, [premiums])

    async function fetchLocationByOrgGuid(orgGuid: string, prov: string) {
        setIsLoading(true)
        try {
            const orgLocationByOrgGuid = await getOrgLocationByOrgGuid(orgGuid, prov)
            const option: ddlListItem = { name: orgLocationByOrgGuid.organizationname, id: orgLocationByOrgGuid.organizationid }
            setOrgLocationOption(option)
        } catch (error: any) {
            toast.error('Error - Could not load Location')
            fetchSchoolBoards(parentFormData.Province)
            setParentFormData((prevState) => ({
                ...prevState,
                ["OrgGuid"]: "",
            }))
            setRouteParam(parentFormData.Province.id, parentFormData.Language, true);
            childPlanFormData.map((child, i) => {
                const dataInput = child.ChildPlanFormDataInput.find(
                    (x) => x.Name === 'School'
                )
                if (dataInput != null) {
                    const updated = {
                        ...dataInput,
                        Disabled: false,
                    }
                    const updatedFormInputs = [...child.ChildPlanFormDataInput]
                    const index = updatedFormInputs.indexOf(dataInput)
                    updatedFormInputs[index] = updated

                    setChildPlanFormData((prevFormData) => {
                        const newFormData = [...prevFormData]
                        newFormData[i] = {
                            ...child,
                            ChildPlanFormDataInput: updatedFormInputs,
                            ['Plan']: {
                                PlanCode: "",
                                Primary: "",
                                Premium: -1,
                                Index: -1,
                                IsValid: false
                            }
                        }
                        return newFormData
                    })
                }
            })
            // updateSchoolBoardDDLItems([])
            // disableProvinceDDL(parentFormData, setParentFormData)
            // disableSchoolBoardDDL(setParentFormData)
        } finally {
            setIsLoading(false)
        }
    }

    async function fetchSchoolBoards(prov: ddlListItem) {
        setIsLoading(true)
        try {
            const schoolBoards = await getSchoolBoards(prov.id)
            const options: ddlListItem[] = schoolBoards.map((sb) => ({
                name: sb.organizationname,
                id: sb.organizationid,
            }))
            updateSchoolBoardDDLItems(options)
        } catch (error: any) {
            if (error.response.status != 404) {
                toast.error('Error - Could not load School Boards')
            } else {
                //Reset DDL list for School and SchoolBoard
                updateSchoolBoardDDLItems([])
            }
        } finally {
            setIsLoading(false)
        }
    }

    async function fetchSchools(id: number) {
        setIsLoading(true)
        setParentFormData((prevFormData) => {
            const newFormData = {
                ...prevFormData,
                SchoolListItems: [{ name: `${t('other')}`, id: -1 }],
            }
            return newFormData
        })
        try {
            const schools = await getSchools(id)
            const options: ddlListItem[] = schools.map((s) => ({
                name: s.schoolname,
                id: s.organizationschoolid,
            }))
            options.unshift({ name: `${t('other')}`, id: -1 })
            setParentFormData((prevFormData) => {
                const newFormData = {
                    ...prevFormData,
                    SchoolListItems: options,
                }
                return newFormData
            })
        } catch (error: any) {
            setParentFormData((prevFormData) => {
                const newFormData = {
                    ...prevFormData,
                    SchoolListItems: [{ name: `${t('other')}`, id: -1 }],
                }
                return newFormData
            })
            if (error.response.status != 404) {
                toast.error(`${t('errorCouldNotLoadSchools')}`)
            }
        } finally {
            setIsLoading(false)
        }
    }

    const setDefaultOrgLocation = (option: ddlListItem) => {
        setParentFormData((prevFormData) => {
            const newFormData = {
                ...prevFormData,
                DoNotOffer: false,
                SchoolBoard: option,
                CommonChildPlanFormInputData: {
                    ...prevFormData.CommonChildPlanFormInputData,
                    ListItems: [option],
                    IsBlur: true,
                    IsFocus: false,
                    IsValid: true,
                    Disabled: true,
                },
            };
            return newFormData;
        });
    }

    const updateSchoolBoardDDLItems = (options: ddlListItem[]) => {
        setParentFormData((prevFormData) => {
            const newFormData = {
                ...prevFormData,
                DoNotOffer: options.length === 0 ? true : false,
                CommonChildPlanFormInputData: {
                    ...prevFormData.CommonChildPlanFormInputData,
                    ListItems: options,
                },
            };
            return newFormData;
        });
    }

    async function getPlanDurations(language: number) {
        setPlanDurationsLoading(true)
        try {
            const planDurr = await getCodeDescription('saimultiyr', language)
            setPlanDurations(planDurr)
            createPlanDurationOptions(planDurr)
        } catch (error) {
            toast.error(`${t('errorCouldNotLoadPlanDurations')}`)
        } finally {
            setPlanDurationsLoading(false)
        }
    }

    const createPlanDurationOptions = (planDurr: ICodeDescription[]) => {
        const planDurationOptions = planDurr.map((pd, index) => ({
            mainText: pd.description,
            secondaryText:
                pd.code == '3'
                    ? '5perDiscount'
                    : pd.code == '5'
                        ? '10perDiscount'
                        : '',
            name: 'PlanDuration',
            index: index,
            value: pd.code,
        }))

        setPlanDurationOptions(planDurationOptions)
    }

    const handleButtonSelectChange = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        primary: string,
        secondary: string,
        i: number
    ) => {
        const { name, value } = e.currentTarget

        switch (name) {
            case 'PlanDuration':
                setParentFormData((prevFormData) => {
                    let newFormData = { ...prevFormData }
                    newFormData = {
                        ...prevFormData,
                        [name]: {
                            DurationText: primary,
                            Duration: Number(value),
                            Discount: secondary,
                            Index: i,
                        },
                        ['AutoEnroll']: {
                            Renew: '',
                            Index: -1,
                            IsValid: false,
                        },
                    }
                    return newFormData
                })
                childPlanFormData.map((child, index) => {
                    setChildPlanFormData((prevFormData) => {
                        const planCode = child.Plan.PlanCode ?
                            child.Plan.PlanCode.slice(0, -1) + value : ""
                        const newFormData = [...prevFormData]
                        newFormData[index] = {
                            ...child,
                            ['Plan']: {
                                PlanCode: planCode,
                                Primary: child.Plan.Primary,
                                Premium: premiumOptions[planCode],
                                Index: child.Plan.Index,
                                IsValid: true
                            },
                        }
                        return newFormData
                    })
                })
                break
            case 'AutoEnroll':
                setParentFormData((prevFormData) => {
                    let newFormData = { ...prevFormData }
                    newFormData = {
                        ...prevFormData,
                        [name]: {
                            Renew: value,
                            Index: i,
                            IsValid: false,
                        },
                    }
                    return newFormData
                })
                break
        }
    }

    const handleDDLChange = (name: string, value: any) => {
        switch (name) {
            case 'SchoolBoard':
                let isValid: boolean = false
                let errorMessage: string = ''
                const dataInput = parentFormData.CommonChildPlanFormInputData
                if (dataInput != null) {
                    // Validation - required
                    if (dataInput.Required && !value?.name) {
                        isValid = false
                        const temp = dataInput.ErrorMessageList.find(
                            (x) => x.type === 'required'
                        )
                        if (temp != null) {
                            errorMessage = temp.error
                        }
                    } else {
                        isValid = true
                    }

                    const updatedDataInput = {
                        ...dataInput,
                        IsBlur: true,
                        IsFocus: false,
                        IsValid: isValid,
                        ErrorMessage: errorMessage,
                    }

                    if (parentFormData?.SchoolBoard?.id !== value?.id) {
                        setParentFormData((prevFormData) => {
                            let newFormData = { ...prevFormData }
                            newFormData = {
                                ...prevFormData,
                                [name]: value,
                                CommonChildPlanFormInputData: updatedDataInput,
                            }
                            return newFormData
                        })
                        childPlanFormData.map((child, index) => {
                            const schoolInput = child.ChildPlanFormDataInput.find(
                                (x) => x.Name === 'School'
                            )
                            if (schoolInput != null) {
                                let updatedSchoolInput = { ...schoolInput }

                                if (schoolInput.IsBlur) {
                                    updatedSchoolInput = {
                                        ...schoolInput,
                                        ListItems: [],
                                        IsBlur: true,
                                        IsFocus: false,
                                        IsValid: false,
                                        ErrorMessage: 'Required',
                                    }
                                }

                                const updatedFormInputs = [
                                    ...child.ChildPlanFormDataInput,
                                ]
                                const schoolIndex =
                                    updatedFormInputs.indexOf(schoolInput)
                                updatedFormInputs[schoolIndex] = updatedSchoolInput

                                setChildPlanFormData((prevFormData) => {
                                    const newFormData = [...prevFormData]
                                    newFormData[index] = {
                                        ...child,
                                        ['School']: { name: '', id: -1 },
                                        ChildPlanFormDataInput: updatedFormInputs,
                                    }
                                    return newFormData
                                })
                            }
                        })
                    }
                }
                break
            default:
                setParentFormData((prevFormData) => {
                    let newFormData = { ...prevFormData }
                    newFormData = { ...parentFormData, [name]: value }
                    return newFormData
                })
        }
    }

    const handleDDLBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name } = e.target
        let isValid: boolean = false
        let errorMessage: string = ''
        const dataInput = parentFormData.CommonChildPlanFormInputData
        if (dataInput != null) {
            // Validation - required
            if (dataInput.Required && !parentFormData[name]?.name) {
                isValid = false
                const temp = dataInput.ErrorMessageList.find(
                    (x) => x.type === 'required'
                )
                if (temp != null) {
                    errorMessage = temp.error
                }
            } else {
                isValid = true
            }

            const updatedDataInput = {
                ...dataInput,
                IsBlur: true,
                IsFocus: false,
                IsValid: isValid,
                ErrorMessage: errorMessage,
            }

            setParentFormData((prevState) => ({
                ...prevState,
                CommonChildPlanFormInputData: updatedDataInput,
            }))
        }
    }

    const handleDDLFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        const dataInput = parentFormData.CommonChildPlanFormInputData

        if (dataInput != null) {
            const updatedDataInput = {
                ...dataInput,
                IsBlur: false,
                IsFocus: true,
            }

            setParentFormData((prevState) => ({
                ...prevState,
                CommonChildPlanFormInputData: updatedDataInput,
            }))
        }
    }

    const setDefaultPlanDuration = () => {
        setParentFormData((prevFormData) => {
            let newFormData = { ...prevFormData }
            newFormData = {
                ...prevFormData,
                ['PlanDuration']: {
                    DurationText:
                        planDurationOptions.find(
                            (x) =>
                                x.value ===
                                prevFormData.PlanDuration.Duration.toString()
                        )?.mainText || '',
                    Duration: prevFormData.PlanDuration.Duration,
                    Discount:
                        planDurationOptions.find(
                            (x) =>
                                x.value ===
                                prevFormData.PlanDuration.Duration.toString()
                        )?.secondaryText || '',
                    Index:
                        planDurationOptions.find(
                            (x) =>
                                x.value ===
                                prevFormData.PlanDuration.Duration.toString()
                        )?.index || 0,
                },
                ['AutoEnroll']: {
                    Renew:
                        enrollOptions.find(
                            (x) => x.value === prevFormData.AutoEnroll.Renew
                        )?.mainText || '',
                    Index:
                        enrollOptions.find(
                            (x) => x.value === prevFormData.AutoEnroll.Renew
                        )?.index || 0,
                    IsValid: false,
                },
            }
            return newFormData
        })
    }
    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        const dataInput = parentFormData.CommonChildPlanStartDate

        if (dataInput != null) {
            const updatedDataInput = {
                ...dataInput,
                IsBlur: false,
                IsFocus: true,
            }
            setParentFormData((prevState) => ({
                ...prevState,
                CommonChildPlanStartDate: updatedDataInput,
            }))
        }
    }

    const handleDatePickerSelect = (selectedDate: Date) => {
        const dataInput = parentFormData.CommonChildPlanStartDate
        if (dataInput != null) {
            const updatedDataInput = {
                ...dataInput,
                IsBlur: false,
                IsFocus: true,
                IsValid: true,
            }
            setParentFormData((prevState) => ({
                ...prevState,
                CommonChildPlanStartDate: updatedDataInput,
                StartDate: selectedDate
            }))
        }
        setInputDateValue(parseDate(selectedDate))
    }

    const handleDateChange = (date: Date | null) => {
        setParentFormData((prevState) => ({
            ...prevState,
            StartDate: date,
        }))
        setInputDateValue(parseDate(date))
    }

    const handleInputDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = formatInputDate(event.target.value);
        if (newValue === '') {
            setParentFormData((prevState) => ({
                ...prevState,
                StartDate: newValue
            }))
        }
        setInputDateValue(newValue);
    };

    const handleInputDateBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        let isValid: boolean = false
        let errorMessage: string = ''

        const dataInput = parentFormData.CommonChildPlanStartDate
        const inputDate = new Date(e.target.value);
        let date: any = null;
        if (dataInput != null) {
            // Validation - required
            if (dataInput.Required && !value) {
                isValid = false
                errorMessage = 'required'
            }
            else {
                isValid = true
            }

            // Validation - pattern match
            if (isValid) {
                const regex = RegExp(dataInput.Pattern)
                console.log((inputDate.getDate() >= minDate.getDate()) + "inputDate: " + inputDate + " minDate: " + minDate)
                if ((dataInput.Pattern !== '' && !regex.test(value)) || !(parseDate(inputDate) >= parseDate(minDate) && parseDate(inputDate) < parseDate(maxDate))) {
                    isValid = false
                    errorMessage = 'required'
                    setInputDateValue('')
                } else {
                    isValid = true
                    date = new Date(value);
                }
            }
            const updatedDataInput = {
                ...dataInput,
                IsBlur: true,
                IsFocus: false,
                IsValid: isValid,
                ErrorMessage: errorMessage,
            }
            setParentFormData((prevState) => ({
                ...prevState,
                CommonChildPlanStartDate: updatedDataInput,
                StartDate: date
            }))
        }
    }

    return (
        <div ref={forwardedAutoEnrollRef} className={classNames(className, "flex justify-center")}>
            <div className='flex bg-white lg:w-[55rem] md:w-[31rem] w-[20rem] shadow-md py-6 justify-center'>
                <div className='lg:w-[42rem] w-[18rem] relative'>
                    <h1 className="text-lg font-bold text-center lg:pb-0 pb-4">
                        {t('PolicyInfo')}
                    </h1>
                    <div className='flex flex-col justify-center items-center lg:grid lg:grid-cols-2 lg:space-x-2 space-y-5'>
                        <div className='flex flex-row relative w-[14rem] md:w-[17rem]'>
                            <div className={classNames('lg:pt-5 lg:ml-2', parentFormData.Language == 0 ? "" : "lg:text-[0.98rem]")}>
                                <InputBox
                                    key={parentFormData.CommonChildPlanStartDate.Id}
                                    type='DatePicker'
                                    // inputID={parentFormData.CommonChildPlanStartDate.Id}
                                    inputID='CoverageDatePicker'
                                    label={t(parentFormData.CommonChildPlanStartDate.Label) || ''}
                                    // className={
                                    //     parentFormData.CommonChildPlanStartDate.ClassName
                                    // }
                                    width={parentFormData.CommonChildPlanStartDate.Width}
                                    height={parentFormData.CommonChildPlanStartDate.Height}
                                    shadow={parentFormData.CommonChildPlanStartDate.Shadow}
                                    onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                    ) => handleInputDateChange(e)}
                                    onBlur={(
                                        e: any
                                    ) => handleInputDateBlur(e)}
                                    onFocus={(
                                        e: any
                                    ) => handleFocus(e)}
                                    value={inputDateValue ? inputDateValue : (parentFormData.StartDate ? parseDate(parentFormData.StartDate) : '')}
                                    name={parentFormData.CommonChildPlanStartDate.Name}
                                    required={parentFormData.CommonChildPlanStartDate.Required}
                                    error={
                                        t(parentFormData.CommonChildPlanStartDate
                                            .ErrorMessage) || ''
                                    }
                                    isValid={
                                        parentFormData.CommonChildPlanStartDate.IsValid
                                    }
                                    isBlur={
                                        parentFormData.CommonChildPlanStartDate.IsBlur
                                    }
                                    isFocus={parentFormData.CommonChildPlanStartDate.IsFocus}
                                    placeholder={t(parentFormData.CommonChildPlanStartDate.Placeholder) || ''}
                                />
                            </div>
                            <div className='absolute inset-y-0 flex items-center justify-center pt-12 lg:right-[-3.2rem] right-[0.33rem] lg:pt-5'>
                                <CalendarIcon
                                    inputID={parentFormData.CommonChildPlanStartDate.Id}
                                    maxDate={maxDate}
                                    minDate={getToday()}
                                    handleDateChange={handleDateChange}
                                    selectedDate={parentFormData.StartDate}
                                    // onBlur={handleInputDateBlur}
                                    onFocus={handleFocus}
                                    onSelect={handleDatePickerSelect}
                                />
                            </div>
                        </div>
                        <div className={classNames('lg:pl-0 md:pl-1 pl-0')}>
                            <DropDownList
                                key={parentFormData.CommonChildPlanFormInputData.Id}
                                className={
                                    parentFormData.CommonChildPlanFormInputData.ClassName
                                }
                                width={parentFormData.CommonChildPlanFormInputData.Width}
                                height={parentFormData.CommonChildPlanFormInputData.Height}
                                list={
                                    parentFormData.Province
                                        ? parentFormData.CommonChildPlanFormInputData
                                            .ListItems
                                        : []
                                }
                                label={
                                    t(parentFormData.CommonChildPlanFormInputData.Label) ||
                                    ''
                                }
                                inputID={parentFormData.CommonChildPlanFormInputData.Id}
                                selectedItem={
                                    parentFormData[
                                    parentFormData.CommonChildPlanFormInputData.Name
                                    ]
                                }
                                name={parentFormData.CommonChildPlanFormInputData.Name}
                                required={parentFormData.CommonChildPlanFormInputData.Required}
                                onChange={handleDDLChange}
                                onBlur={handleDDLBlur}
                                onFocus={handleDDLFocus}
                                error={
                                    t(
                                        parentFormData.CommonChildPlanFormInputData
                                            .ErrorMessage
                                    ) || ''
                                }
                                isValid={
                                    parentFormData.CommonChildPlanFormInputData.IsValid
                                }
                                isBlur={parentFormData.CommonChildPlanFormInputData.IsBlur}
                                isFocus={
                                    parentFormData.CommonChildPlanFormInputData.IsFocus
                                }
                                disabled={parentFormData.CommonChildPlanFormInputData.Disabled}
                            />
                        </div>
                    </div>
                    <div className='flex justify-center flex-col items-center'>
                        <p className={classNames("pt-5 pb-5 font-medium md:text-lg text-base text-center lg:w-[25rem] md:w-[20rem] w-[17rem]",)}>
                            {t('planDuration')}
                        </p>
                        {planDurationsLoading ? (
                            <>
                                <PulseLoader color="white" size={25} />
                            </>
                        ) : (
                            <>
                                <ButtonSelect
                                    options={planDurationOptions}
                                    className='hover:bg-[#9ccb45]'
                                    selectColor="bg-[#9ccb45]"
                                    baseColor="bg-white"
                                    textColor="black"
                                    size="h-[4rem] lg:w-[8rem] md:w-[6.85rem] w-[5.5rem]"
                                    textSize="md:text-lg text-xs"
                                    secondaryTextSize="text-xs"
                                    onChange={handleButtonSelectChange}
                                    selected={parentFormData.PlanDuration.Duration.toString()}
                                    loadingSecondary={premiumsLoading}
                                />
                            </>
                        )}
                        {parentFormData.PlanDuration.Duration === 1 && (
                            <div className='text-center flex flex-col justify-center'>
                                <p className={classNames(" pt-9 pb-1 font-medium text-lg")}>
                                    {t('autoEnrollment')}
                                </p>
                                <div className='flex flex-col justify-center items-center'>
                                    <div className={classNames("text-sm items-center", "justify-center lg:w-[25rem] md:w-[20rem] w-[17rem]")}>
                                        <p className='text-center flex justify-center'>{t('renewYearlyText')}.&nbsp;</p>
                                        <p onClick={() => setLearnMoreOpen(!learnMoreOpen)} className='cursor-pointer pt-2'><u>{t('learnMore')}</u></p>
                                        <div className={classNames('border-1 shadow-xl', learnMoreOpen ? "visible h-auto" : "invisible h-0")} >
                                            <div className="text-center justify-center px-10 py-7 ">
                                                <p className="font-bold ">{t('modal-autorenew-line1')}</p>
                                                <p className="text-sm">{t('modal-autorenew-line2')}</p>
                                                <p className="pb-3 text-sm">{t('modal-autorenew-line3')}</p>
                                                <p className="font-bold">{t('modal-autorenew-line4')}</p>
                                                <p className="pb-3 text-sm">{t('modal-autorenew-line5')}</p>
                                                <p className="font-bold">{t('modal-autorenew-line6')}</p>
                                                <p className="text-sm">{t('modal-autorenew-line7')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-center pt-5 ' id='autoEnroll'>
                                    <ButtonSelect
                                        options={enrollOptions}
                                        className='hover:bg-[#9ccb45]'
                                        selectColor="bg-[#9ccb45]"
                                        baseColor="bg-white"
                                        textColor="black"
                                        size="md:h-[4rem] h-[3.5rem] md:w-[8rem] w-[7rem]"
                                        onChange={handleButtonSelectChange}
                                        selected={parentFormData.AutoEnroll.Renew}
                                    />
                                </div>
                                <div>
                                    {parentFormData.AutoEnroll.IsValid &&
                                        !parentFormData.AutoEnroll.Renew && (
                                            <p className="text-red-600 font-semibold mt-2">
                                                *{t('required')}
                                            </p>
                                        )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ChildPlans

